import {SellerError} from './SellerError.js'

export class EmptyEmailSellerError extends SellerError {}
